module.exports = __webpack_public_path__ + "static/media/book-h2o-detail5.2673a12c.jpg";